export default __webpack_public_path__ + "static/mirror-51d61c01490b561a80303098dab65d8c.jpg";